export enum EStore {
  USER = 'user',
  ACCOUNTS = 'accounts',
  WORKSPACES = 'workspaces',
  PREFERENCES = 'preferences',
  UI = 'ui',
  WHITE_LABEL = 'whiteLabel',
  POINTS = 'points',
  ATTACHMENTS = 'attachments',
  USERS = 'users',
  SYNC = 'sync',
  ACTIVE = 'active',
  TWO_FACTOR_AUTHENTICATION = 'twoFactorAuthentication',
}
